/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 渠道系列聚合页
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
@BindAll()
export class ChannelDetailsController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'code',
      infinite: true,
      details: EnumAPI.product_productInfo,
      detailsParams: {
        valueGetter: this.detailsValueGetter,
      },
    });
  }
  /**
   * 详情数据 自定义获取 数据重组
   * @param response
   * @returns
   */
  async detailsValueGetter(response, request) {
    lodash.assign(response, {
      // banner轮播图
      _BannerSwiperImgs: parsesSwiperImgs(response, '46'),
      // content轮播图
      _ProductSwiperImgs: parsesSwiperImgs(response, '13'),
      // 产品列表
      _ProductList: [],
      //下载文件图片
      _DownloadImg: getDownloadList(response, '41'),
      //下载文件文档
      _DownloadDocument: getDownloadList(response, '42'),
      //下载文件精品汇
      _DownloadBoutique: getDownloadList(response, '66'),
      // 是否展示下载列表
      _isDownloadShow: isDownloadShow(response),
    });
    return this.getProductList(response, request.body.categoryCode);
  }

  /**
   * 解析 系列产品列表
   * @param {*} entity 接口数据
   * @return {*}
   * @memberof ProductController
   */
  async getProductList(response, categoryCodeThree) {
    let body = {
      'pageNo': 1,
      'pageSize': 10,
      'search': {
        'categoryCodeThree': categoryCodeThree,
        'platform': 'BPPORTAL',
        'showIsAllSeeProduct': 1,
        'effectiveType': 1,
        'actionType': 1,
      },
    };
    const res = await AjaxBasics.request({
      ...EnumAPI.product_productList,
      body,
    });
    // this.Details.Model.merge({
    //   // 产品列表
    //   _ProductList: lodash.get(response, 'product', []),
    // });
    return lodash.assign(response, {
      _ProductList: lodash.get(res, 'product', []),
    });
  }
}

/**
 * 解析 轮播图
 * @param {*} entity 接口数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSwiperImgs(entity, type) {
  return lodash.filter(lodash.get(entity, 'productLabelsFiles', []), [
    'fileType',
    Number(type),
  ]);
}

/**
 * 解析 下载文档
 * @param {*} entity 接口数据
 * @return {*}
 * @memberof ProductController
 */
function getDownloadList(entity, type) {
  let downLoadList = lodash.filter(
    lodash.get(entity, 'productLabelsFiles', []),
    { 'fileType': Number(type) },
  );
  return downLoadList;
}

/**
 * 是否展示下载列表
 * @param {*} entity 接口数据
 * @return {*}
 * @memberof ProductController
 */
function isDownloadShow(entity) {
  let downLoadList = lodash.filter(
    lodash.get(entity, 'productLabelsFiles', []),
    function (item) {
      return item.fileType == 41 || item.fileType == 42 || item.fileType == 66;
    },
  );
  return downLoadList.length > 0;
}
